import { render } from "./NotificationsHome.vue?vue&type=template&id=36754260&ts=true"
import script from "./NotificationsHome.vue?vue&type=script&lang=ts"
export * from "./NotificationsHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__